import { imgPlayerMenuPremiumRegion } from "@/shared/assets/img";
import { SquarePlusIcon } from "@/shared/icons";
import { SoundButton } from "@/shared/ui";

export default function PlayerMenuPremiumRegion() {
  return (
    <div
      className="h-[5.25rem] px-5 flex items-center gap-3.5"
      style={{
        backgroundImage: `url(${imgPlayerMenuPremiumRegion})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <img src="./svg/player-menu/star.svg" alt="" className="h-[2.75rem] aspect-square shrink-0" />
      <div>
        <div className="text-12 font-extrabold uppercase">ПРЕМИУМ РЕГИОН</div>
        <div className="text-12 font-bold text-accent-solid uppercase mt-1">9 ДНЕЙ</div>
      </div>
      <SoundButton className="p-0 ml-auto h-[2.625rem] aspect-square">
        <SquarePlusIcon size={16} />
      </SoundButton>
    </div>
  );
}
